<template>
  <div>
    <h4>Блокировка</h4>

    <form @submit.prevent="ban">

      <div class="form-group">
        <label for="duration-type-selector">Тип</label>
        <b-form-select
          id="duration-type-selector"
          v-model="durationType"
          :options="durationTypeOptions"
          autofocus
        />
      </div>

      <div v-if="isTemp" class="form-group">
        <label for="ban-duration">Длительность (в днях)</label>
        <input
          type="number"
          id="ban-duration"
          v-model="durationDays"
          class="form-control"
          min="1"
          required
        >
      </div>

      <div class="form-group">
        <label for="reason">Причина</label>
        <textarea
          v-model="reason"
          id="reason"
          class="form-control"
          rows="3"
          maxlength="255"
          required
        />
      </div>

      <b-button :to="{name: targetRoute}">Отмена</b-button>
      <b-button type="submit" variant="danger">
        Заблокировать
      </b-button>
    </form>
  </div>
</template>

<script>
import notifier from '../notifier';
import { HTTP } from '../http-common';

import { BAN_TYPE_TEMP             } from '../model/player_ban.js';
import { getBanDurationTypeOptions } from '../model/player_ban.js';

export default {
  name: 'PlayerBanAdd',

  props: {
    playerId: {
      type: Number,
      required: true,
    },

    // Маршрут, на который нужно перейти после выполнения операции.
    targetRoute: {
      type: String,
      default: 'player_ban_log',
    },
  },

  data() {
    const durationTypeOptions = getBanDurationTypeOptions();

    return {
      durationTypeOptions,
      durationType: durationTypeOptions[0].value,

      durationDays: 10,
      reason: '',
    };
  },

  computed: {
    isTemp() {
      return this.durationType === BAN_TYPE_TEMP;
    },
  },

  methods: {
    ban() {
      notifier.deleteSenderNotifications(this);

      const data = new FormData();

      if(this.isTemp) {
        const durationDays = parseInt(this.durationDays, 10);
        data.set('duration_days', durationDays);
      }

      const trimmedReason = this.reason.trim();
      if(trimmedReason.length === 0) {
        notifier.showError(
          'Reason must be specified.',
          {sender: this},
        );
        return;
      }
      data.set('reason', trimmedReason);

      const url = '/player/' + this.playerId + '/ban';
      HTTP.post(url, data)
      .then(response => {
        const ban = response.data.data;
  
        this.$emit('player-banned', ban.ftime);
        notifier.showSuccessAfterTransition('Player banned.');
        this.$router.push({name: this.targetRoute});
      })
      .catch(err => {
        notifier.showError(err.response.data, {sender: this});
      });
    },
  },
};
</script>
